// Device/browser detection for the Add to Home Screen prompt. Every check
// degrades to false outside a browser (SSR/tests) rather than throwing.

// True once installed, on iOS (navigator.standalone) and everywhere else
// (the display-mode media query). The install prompt must never render here.
export function isStandalone() {
  if (typeof window === 'undefined') return false;
  const viaMediaQuery = typeof window.matchMedia === 'function'
    && window.matchMedia('(display-mode: standalone)').matches;
  const viaIOSFlag = window.navigator?.standalone === true;
  return viaMediaQuery || viaIOSFlag;
}

// iPadOS 13+ reports a Mac user agent unless the user has requested the
// mobile site, so a touch-capable "Mac" is the accepted stand-in for iPad.
export function isIOS() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return true;
  return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
}

// beforeinstallprompt never fires on iOS in any browser, and only Safari's
// share sheet produces a real standalone install there — Chrome/Firefox/Edge
// on iOS all run WebKit under the hood but their "Add to Home Screen" makes a
// plain bookmark, not an installed PWA. Their UA strings self-report even
// though they share WebKit, which is what this excludes.
export function isIOSSafari() {
  if (!isIOS()) return false;
  return !/CriOS|FxiOS|EdgiOS|OPiOS/.test(navigator.userAgent);
}

export function isMobile() {
  if (typeof navigator === 'undefined') return false;
  return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || isIOS();
}
